import { render, staticRenderFns } from "./WorkPermitWeek.vue?vue&type=template&id=8331b762&scoped=true"
import script from "./WorkPermitWeek.vue?vue&type=script&lang=js"
export * from "./WorkPermitWeek.vue?vue&type=script&lang=js"
import style0 from "./WorkPermitWeek.vue?vue&type=style&index=0&id=8331b762&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8331b762",
  null
  
)

export default component.exports